// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"SectionD_TheComp__nAzWP"};